import { TFlex } from 'foundations-components/transitional/components/TFlex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
// import { CONTENT_PLATFORM_PROPERTY_NAME } from 'content-management-data-lib';

// @ts-expect-error Untyped module
import { getDate, getTime } from '../../utils/time';
import CellWithHelpText from './CellWithHelpText';
import { jsx as _jsx } from "react/jsx-runtime";
// @ ts-expect-error Untyped module
// import { getTranslatedScreenReaderTextForTime } from '../../../shared/utils/screenReaderHelpers';

// const getCellType = (propertyName: string): string => {
//   switch (propertyName) {
//     case CONTENT_PLATFORM_PROPERTY_NAME.UPDATED_AT:
//       return 'updated';
//     case CONTENT_PLATFORM_PROPERTY_NAME.CREATED_AT:
//       return 'created';
//     case CONTENT_PLATFORM_PROPERTY_NAME.PUBLISH_DATE:
//       return 'published';
//     default:
//       return '';
//   }
// };
const DateCell = ({
  crmObject,
  propertyName
}) => {
  const dateString = getPropertyValue(crmObject, propertyName);
  if (!dateString) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "content-management-listing-lib.table.cells.emptyValues.date"
    });
  }
  const formattedDate = parseInt(dateString, 10);
  // const cellType = getCellType(propertyName);
  // const contentName = getContentPropertyValue(crmObject, 'NAME');

  return /*#__PURE__*/_jsx(TFlex, {
    direction: "column",
    children: /*#__PURE__*/_jsx(CellWithHelpText, {
      text: getDate(formattedDate),
      helpText: getTime(formattedDate)
      // ariaLabel={getTranslatedScreenReaderTextForTime(
      //   cellType,
      //   formattedDate,
      //   {
      //     date: getDate(formattedDate),
      //     name: contentName,
      //     time: getTime(formattedDate),
      //   }
      // )}
      ,
      truncateHelpText: false,
      truncateMainText: true,
      isCell: false
    })
  });
};
export default DateCell;